<template>
	<div>
		<label :for="fieldName" :class="getLabelClasses(value, focused)">Name</label>
		<input
			:id="fieldName" type="text" :maxlength="maxLength" aria-required="true" :autofocus="autoFocus" :data-enter-target="enterTarget" :placeholder="fieldPrompt" v-model="value"
			:class="getInputClasses()"
			@keyup="handleKeyup"
			@focus="focused=true">
		<InputErrorDisplay :show="valid.length > 0 && formIsDirty && required" :errors="valid"/>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import InputErrorDisplay from '@/components/schreg-common/Forms/InputErrorDisplay.vue';

export default defineComponent({
	name: 'FormInputText',
	components: {
		InputErrorDisplay
	},
	props: {
		fieldName: {
			required: true,
			type: String
		},
		fieldPrompt: {
			required: true,
			type: String
		},
		initialValue: {
			required: false,
			default: null,
			type: String
		},
		defaultValue: {
			required: false,
			default: null,
			type: String
		},
		required: {
			required: false,
			default: true,
			type: Boolean
		},
		formIsDirty: {
			required: true,
			type: Boolean
		},
		maxLength: {
			required: false,
			default: null,
			type: String
		},
		autoFocus: {
			required: false,
			default: false,
			type: Boolean
		},
		enterTarget: {
			required: false,
			default: 'why is the default not replaced?',
			type: String
		}
	},
	data() {
		return {
			value: null,
			focused: false,
			valid: []
		};
	},
	watch: {
		value: function() {
			this.$emit('changed', this.fieldName, this.value);
		}
	},
	mounted() {
		this.setInitialValue();
	},
	destroyed() {

	},
	methods: {
		setInitialValue() {
			this.value = null;
			if (this.initialValue) {
				this.value = this.initialValue;
			}
			if (this.defaultValue && !this.value) {
				this.value = this.defaultValue;
			}
		},
		handleKeyup() {
			this.handleTriggerValidation();
		},
		validate(customValidation) {
			return this.validateField(customValidation);
		},
		getId() {
			return this.fieldName;
		},
		getValue() {
			return this.value;
		},
		setValue(value) {
			this.value = value;
		},
		getLabelClasses(prop, focused) {
			if (prop !== '') {
				return [
					{ 'has-value': prop },
					{ 'has-focus': focused },
					{ 'float-label': true }
				];
			}
		},
		getInputClasses() {
			return [
				{ 'form-control-danger': this.valid.length && this.formIsDirty },
				{ 'form-control': true }
			];
		},
		handleTriggerValidation() {
			this.$emit('validate');
		},
		validateField(customValidation) {
			this.valid = [];
			if (typeof customValidation === 'object') {
				for (const customFunc of customValidation) {
					const customResult = customFunc(this.fieldName, this.value);
					if (customResult) {
						this.valid.push(customResult);
					}
				}
			}
			return this.valid.length === 0;
		}
	}
});
</script>
